/* eslint-disable @typescript-eslint/no-var-requires */

import { colors } from '@lmc/common/constants'
import dayjs from 'dayjs'
import Highcharts from 'highcharts'
import ReactHighcharts from 'highcharts-react-official'
import React, { type ReactElement, useRef } from 'react'

// import HighchartsMore from 'highcharts/highcharts-more'
// the code fails bellow, so I just commented it
// HighchartsMore(ReactHighcharts.Highcharts)

interface LineChartProps {
  data: {
    x: string
    y: number
  }[]
}

export function LineChart({ data }: LineChartProps): ReactElement {
  const chartComponentRef = useRef(null)

  const config = {
    title: {
      text: ''
    },
    chart: {
      height: 560
    },
    plotOptions: {
      series: {
        label: {
          connectorAllowed: false
        }
      }
    },
    xAxis: {
      type: 'datetime'
    },
    yAxis: {
      title: { text: 'Occupant count' }
    },
    legend: { enabled: false },
    tooltip: {
      pointFormat: 'Occupancy: {point.y}',
      headerFormat:
        '<span style="font-size: 10px">{point.key:%d-%m-%Y}</span><br/>'
    },
    credits: {
      enabled: false
    },
    series: [
      {
        type: 'spline',
        color: colors.darkpurple,
        data: data.map((d: any) => ({
          x: dayjs(d.x).toDate(),
          y: d.y
        }))
      }
    ]
  }

  return (
    <ReactHighcharts
      options={config}
      highcharts={Highcharts}
      ref={chartComponentRef}
    />
  )
}

export default LineChart
